export const CSS = {
  container: "container",
  track: "track",
  handle: "handle",
};
